// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".base-simple-timer[data-v-521e11df]{display:flex;align-items:center}.base-simple-timer__seconds[data-v-521e11df]{width:.9em;text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
